import { HashRouter, Route } from "react-router-dom";
import React from "react";
import "firebase/firestore";
import SignIn from "./components/SignIn";
import { useAuthState } from "react-firebase-hooks/auth";
import "firebase/auth";
import firebase from "./Firebase";
import { GlobalStyle } from "./styles/GlobalStyle";
import { ChatRoomStyle } from "./styles/ChatRoomStyle";
import CommonChatRoom from "./components/CommonChatRoom";

const App: React.FC = () => {
  const auth = firebase.auth();
  useAuthState(auth);
  const currentUser = auth.currentUser?.uid;
  return (
    <>
      <HashRouter>
        <ChatRoomStyle>
          {currentUser ? (
            <>
              <Route exact path="/user/:id" children={<CommonChatRoom />} />
              <Route exact path="/" children={<CommonChatRoom />} />
            </>
          ) : (
            <Route exact path="/sign-in" children={<SignIn auth={auth} />} />
          )}
        </ChatRoomStyle>
      </HashRouter>
      <GlobalStyle />
    </>
  );
};

export default App;
